module.exports = __webpack_public_path__ + "media/images/wf_logo_3-9db2c1e5119f44b43cb68525533e5723.png";